const dataLogin = (res) => {
  localStorage.setItem("token", res.data.accessToken);
  localStorage.setItem("refreshToken", res.data.refreshToken);
  localStorage.setItem("username", res.data.username);
  localStorage.setItem("isAuth", true);
  localStorage.setItem("roles", res.data.roles);
};

export default dataLogin;
